import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { commonPostPutApi } from "../../../redux/reducers/commonApiSlice";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import Loader from "../../ui/Loader";

const RegularizationApprovalForm = ({
  userInfoData,
  type,
  rowData,
  callFunction,
  onCloseModal,
}) => {
  const dispatch = useDispatch();
  const { postPutLoading1 } = useSelector((state) => state.common);

  const forminitials = {
    description: "",
  };
  const [formValues, setFormValues] = useState(forminitials);
  const [formErrors, setFormErrors] = useState({});

  const validateForm = (formValues) => {
    let errors = {};

    if (!formValues.description) {
      errors.description = "required!";
    }

    return errors;
  };

  const handleSubmitForm = async (payload) => {
    const method = "POST";
    const endpoint = "/attandance/regularization/approve";
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Success!");
        setFormValues(forminitials);
        callFunction();
        onCloseModal();
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  const onSubmit = (isReject) => {
    const errors = validateForm(formValues);
    setFormErrors(errors);

    if (Object.keys(errors)?.length === 0) {
      const userData = {
        uid: rowData?.uid || "",
        type: type === "manager_approve" ? "manager" : "hr",
        approval_status: isReject ? "rejected" : "approved",
        remarks: formValues.description || "",
      };

      const handleConfirm = async () => {
        handleSubmitForm(userData);
      };

      showConfirmAlert(
        handleConfirm,
        `Are you sure you want to ${
          isReject ? "reject" : "approve"
        } this request?`,
        "No, Cancel",
        "Yes, Submit Form"
      );
    }
  };

  return (
    <form className="formContainer mb15">
      <div className="formInputsGrid oneGridSystem">
        <div className="formInputBox span4">
          <label htmlFor="description" className="formInputLabel">
            remarks <span className="required">*</span>
          </label>

          <textarea
            name="description"
            className={`formInput ${formErrors.description ? "formError" : ""}`}
            style={{
              background: "#fff",
              minHeight: "150px",
            }}
            placeholder="Enter Remarks"
            value={formValues.description || ""}
            onChange={(e) =>
              setFormValues((prevs) => ({
                ...prevs,
                description: e.target.value,
              }))
            }
          ></textarea>
        </div>
      </div>

      <div className="formButtons" style={{ justifyContent: "flex-end" }}>
        {postPutLoading1 ? (
          <Loader />
        ) : (
          <>
            <Button
              className="saveBtn"
              variant="primary"
              onClick={() => onSubmit(false)}
            >
              approve
            </Button>
            <Button
              className="saveBtn"
              variant="danger"
              onClick={() => onSubmit(true)}
            >
              reject
            </Button>
          </>
        )}
      </div>
    </form>
  );
};

export default RegularizationApprovalForm;
